import React, { useState } from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { StickyNote } from 'lucide-react';
import LeadNotesDialog from './LeadNotesDialog';
import LeadCard from './LeadCard';
import { OrigenTag } from './leadOrigen';
export { ORIGENES } from './leadOrigen';

export const ETAPAS = [
  { value: 'nuevo', label: 'Nuevo', className: 'bg-blue-500/20 text-blue-300 border-blue-500/30' },
  { value: 'contactado', label: 'Contactado', className: 'bg-amber-500/20 text-amber-300 border-amber-500/30' },
  { value: 'cotizado', label: 'Cotizado', className: 'bg-violet-500/20 text-violet-300 border-violet-500/30' },
  { value: 'cerrado', label: 'Cerrado', className: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30' },
];

const formatDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  return d.toLocaleString('es-VE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const SubscribersTable = ({ subscribers, loading, onUpdateLead }) => {
  const [editing, setEditing] = useState(null);

  if (loading && subscribers.length === 0) {
    return <div className="py-16 text-center text-slate-400" data-testid="admin-table-loading">Cargando leads...</div>;
  }
  if (subscribers.length === 0) {
    return <div className="py-16 text-center text-slate-400" data-testid="admin-table-empty">No hay suscriptores que coincidan.</div>;
  }
  return (
    <>
    <div className="md:hidden space-y-3" data-testid="admin-leads-cards">
      {subscribers.map((s) => <LeadCard key={s.id} lead={s} etapas={ETAPAS} formatDate={formatDate} onUpdateLead={onUpdateLead} onEditNotes={setEditing} />)}
    </div>
    <div className="hidden md:block overflow-x-auto rounded-2xl border border-white/10">
      <table className="w-full text-sm" data-testid="admin-subscribers-table">
        <thead className="bg-white/5 text-left text-slate-400 uppercase text-xs tracking-wider">
          <tr>
            <th className="px-4 py-3 font-medium">Nombre</th>
            <th className="px-4 py-3 font-medium">Email</th>
            <th className="px-4 py-3 font-medium">Teléfono</th>
            <th className="px-4 py-3 font-medium">Interés</th>
            <th className="px-4 py-3 font-medium">Estado</th>
            <th className="px-4 py-3 font-medium">Etapa</th>
            <th className="px-4 py-3 font-medium">Notas</th>
            <th className="px-4 py-3 font-medium">Fecha</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/5">
          {subscribers.map((s) => {
            const etapa = ETAPAS.find((e) => e.value === (s.etapa || 'nuevo')) || ETAPAS[0];
            return (
              <tr key={s.id} data-testid="admin-subscriber-row" className="hover:bg-white/5 transition-colors">
                <td className="px-4 py-3 font-medium text-white"><div className="flex flex-col gap-1">{s.nombre}<OrigenTag origen={s.origen} /></div></td>
                <td className="px-4 py-3 text-slate-300">
                  <a href={`mailto:${s.email}`} className="hover:text-blue-400 transition-colors">{s.email}</a>
                </td>
                <td className="px-4 py-3 text-slate-300">{s.telefono || '—'}</td>
                <td className="px-4 py-3 text-slate-300">{s.tipo_seguro || '—'}</td>
                <td className="px-4 py-3">
                  <Badge className={`border-0 ${s.estado === 'cancelado' ? 'bg-red-500/20 text-red-300' : 'bg-emerald-500/20 text-emerald-300'}`}>
                    {s.estado}
                  </Badge>
                </td>
                <td className="px-4 py-3">
                  <select
                    data-testid="lead-etapa-select"
                    value={s.etapa || 'nuevo'}
                    onChange={(e) => onUpdateLead(s.id, { etapa: e.target.value })}
                    className={`h-8 px-2 rounded-lg border text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500/40 bg-slate-900 ${etapa.className}`}
                  >
                    {ETAPAS.map((e) => <option key={e.value} value={e.value} className="bg-slate-900 text-white">{e.label}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 max-w-[220px]">
                  <Button
                    data-testid="lead-notes-btn"
                    size="sm"
                    variant="ghost"
                    onClick={() => setEditing(s)}
                    className={`h-8 px-2 rounded-lg hover:bg-white/10 hover:text-white ${s.notas ? 'text-amber-300' : 'text-slate-400'}`}
                    title={s.notas || 'Agregar nota'}
                  >
                    <StickyNote className="h-4 w-4 mr-1" />
                    <span className="truncate max-w-[160px]">{s.notas ? s.notas : 'Agregar nota'}</span>
                  </Button>
                </td>
                <td className="px-4 py-3 text-slate-400 whitespace-nowrap">{formatDate(s.fecha_suscripcion)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
      <LeadNotesDialog
        lead={editing}
        onClose={() => setEditing(null)}
        onSave={async (notas) => { await onUpdateLead(editing.id, { notas }); setEditing(null); }}
      />
    </>
  );
};

export default SubscribersTable;
